"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.funnel_person = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var funnel_person = function funnel_person(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'funned-person-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M17.2372 3.28851C17.6301 3.41949 17.8425 3.84423 17.7115 4.23719L13.7115 16.2372C13.5805 16.6301 13.1558 16.8425 12.7628 16.7115C12.3699 16.5805 12.1575 16.1558 12.2885 15.7628L16.2885 3.76285C16.4195 3.36989 16.8442 3.15752 17.2372 3.28851Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M2.76285 3.28851C2.36989 3.41949 2.15752 3.84423 2.28851 4.23719L6.28851 16.2372C6.41949 16.6301 6.84423 16.8425 7.23719 16.7115C7.63015 16.5805 7.84252 16.1558 7.71153 15.7628L3.71153 3.76285C3.58055 3.36989 3.15581 3.15752 2.76285 3.28851Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    d: 'M7.00002 9.50002C7.00002 8.67159 7.67159 8.00002 8.50002 8.00002H11.5C12.3284 8.00002 13 8.67159 13 9.50002V10C13 10.5523 12.5523 11 12 11H8.00002C7.44774 11 7.00002 10.5523 7.00002 10V9.50002Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    d: 'M8.50002 6.50002C8.50002 5.67159 9.17159 5.00002 10 5.00002C10.8284 5.00002 11.5 5.67159 11.5 6.50002C11.5 7.32845 10.8284 8.00002 10 8.00002C9.17159 8.00002 8.50002 7.32845 8.50002 6.50002Z',
    fill: '#4B5563'
  }));
};

exports.funnel_person = funnel_person;